// Cycles light → dark → paper. The themes have been in styles.css all along;
// this is the knob that finally reaches them.

import { useEffect, useState } from 'react';
import { THEME_EVENT, cycleTheme, getTheme } from './theme';
import type { Theme } from './theme';

const GLYPHS: Record<Theme, string> = {
  light: '☀',
  dark: '☾',
  paper: '¶',
};

function ThemeToggle() {
  const [theme, setThemeState] = useState<Theme>(() => getTheme());

  useEffect(() => {
    const sync = () => setThemeState(getTheme());
    window.addEventListener(THEME_EVENT, sync);
    return () => window.removeEventListener(THEME_EVENT, sync);
  }, []);

  return (
    <button
      className="theme-toggle"
      type="button"
      onClick={() => setThemeState(cycleTheme())}
      aria-label={`Theme: ${theme}. Activate to switch.`}
      title="Cycle theme"
    >
      <span className="glyph" aria-hidden>
        {GLYPHS[theme]}
      </span>
      <span>{theme}</span>
    </button>
  );
}

export default ThemeToggle;
